import React, { useContext } from "react";
import { GlobalAppContext } from "./../../context";

function SideBarClose() {
  const { toggled, setToggled } = useContext(GlobalAppContext);
  return (
    <React.Fragment>
      <div id="show-sidebar" className="sidebar-icon">
        <a className="p-2 ml-0 mt-0" onClick={() => setToggled(!toggled)}>
          <i className="fa fa-bars icon"></i>
        </a>
      </div>
    </React.Fragment>
  );
}
export default SideBarClose;
